import React, { useEffect, useState, useContext } from "react";
import RoundProgress from "../components/RoundProgress";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { pageFarmCohort } from "../redux/actions/modal";
import BNB from "../assets/images/bnb.png";
import WBNB from "../assets/images/wbnb.png";
import BUSD from "../assets/images/busd.png";
import RASKO from "../assets/images/rasko.png";
import arrow_left from "../assets/images/page-icons/arrow-left.svg";
import { Web3Context } from "../contexts/Web3Context";
import {
  getCohortContract,
  isApprovedForAmount,
  approveErc20,
  weiToEth,
  ethToWei,
  getERC20BalanceFromAddress,
} from "../apis/blockchain";
import * as cohortApi from "../apis/cohort";
import { rAskoAddress, rAskoCohortAddress } from "../constants/addresses";
import { roundString } from "../apis/utils";
import CohortLoading from "../components/IconsSVG";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import { connectWallet } from "../redux/actions/modal";

export default function () {
  const Swal = require("sweetalert2");
  const web3Context = useContext(Web3Context);

  const [depositAmount, setDepositAmount] = useState("0");
  const [depositedAmount, setDepositedAmount] = useState("0");
  const [rewards, setRewards] = useState(["0", "0", "0"]);
  const [allDepositedAmount, setAllDepositedAmount] = useState("0");
  const [userShare, setUserShare] = useState("0");
  const [yearlyBusd, setYearlyBusd] = useState("0");
  const [yearlyWbnb, setYearlyWbnb] = useState("0");

  // const [remaining, setRemaining] = useState([0, 0, 0]);
  const [apy, setApy] = useState("120");
  const [busd, setBusd] = useState("0");
  const [rasko, setRasko] = useState("0");
  const [withdrawAmount, setWithdrawAmount] = useState("0");
  const [bnb, setBnb] = useState("0");
  const [userApproved, setUserApproved] = useState(false);
  const [maxBool, setMaxBool] = useState(false);
  const [userBalance, setUserBalance] = useState("0");
  const [aproveIsLoading, setAproveIsLoading] = useState(false);
  const [claimIsLoading, setClaimIsLoading] = useState(false);
  const [withdrawIsLoading, setWithdrawIsLoading] = useState(false);
  const [withdrawActive, setWithdrawActive] = useState(false);
  const [claimActive, setClaimActive] = useState(false);
  const [approveActive, setAproveActive] = useState(true);
  const dispatch = useDispatch();
  let history = useHistory();

  const changeDeposit = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9]/g, "");
    value = value <= Number(userBalance) ? value : userBalance;
    e.target.value = value;
    setDepositAmount(value);
  };

  const changeBnb = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9]/g, "");
    e.target.value = value;
    // setBnb(value);
  };

  const changeRasko = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9]/g, "");
    e.target.value = value;
    // setRasko(value);
  };

  const changeBusd = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9]/g, "");
    e.target.value = value;
    // setBusd(value);
  };

  const changeWithdraw = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9]/g, "");
    value = value <= Number(depositedAmount) ? value : depositedAmount;
    e.target.value = value;
    setMaxBool(false);
    setWithdrawAmount(value);
  };

  const setMaxWithdraw = (e) => {
    Swal.fire({
      title: "You have chosen to Max. Withdraw",
      text: "Using this function will automatically withdraw and claim all rewards.",
      icon: "info",
      confirmButtonText: "Approve",
    });
    e.preventDefault();
    setWithdrawAmount(depositedAmount);
    setMaxBool(true);
  };

  const setMaxDeposit = (e) => {
    e.preventDefault();
    setDepositAmount(userBalance);
  };

  const handleDeposit = async (e) => {
    e.preventDefault();
    if (isNaN(depositAmount) || depositAmount == 0) {
      dispatch(
        confirm({
          text: "Please enter an amount greater than 0 to deposit.",
          textButton: "OK",
        })
      );
      return;
    }
    dispatch(
      pageFarmCohort({
        rasko: apy,
        busd: yearlyBusd,
        wbnb: yearlyWbnb,
        amount: depositAmount,
        method: "deposit",
      })
    );
    // try {
    //   if (isNaN(depositAmount) || depositAmount == 0) {
    //     alert("Please enter an amount greater than 0 to deposit");
    //     return;
    //   }
    //   // check for approval again
    //   const approved = await isApprovedForAmount(
    //     web3Context.web3.web3Provider,
    //     rAskoAddress,
    //     web3Context.currentAccountAddress,
    //     rAskoCohortAddress,
    //     depositAmount
    //   );

    //   if (!approved) {
    //     await handleApprove();
    //   } else {
    //     const depositWei = ethToWei(depositAmount);
    //     await cohortApi.deposit(
    //       await getCohortContract(web3Context.web3.web3Provider),
    //       depositWei
    //     );
    //     alert(`Deposited ${roundString(depositAmount, 2)}`);
    //     await handleGetInfo();
    //     setDepositAmount("0");
    //   }
    // } catch (e) {
    //   console.log(e);
    // }
  };

  const handleWithdraw = async (e) => {
    e.preventDefault();
    if (depositedAmount == 0) {
      Swal.fire({
        text: "You have not deposited any amount yet",
        icon: "info",
        confirmButtonText: "Ok",
      });
      return;
    }
    if (withdrawAmount == 0) {
      Swal.fire({
        text: "Please enter an amount greater than 0 to withdraw",
        icon: "info",
        confirmButtonText: "OK",
      });
      return;
    }
    if (maxBool) {
      try {
        setWithdrawIsLoading(true);
        await cohortApi.withdrawAll(
          await getCohortContract(web3Context.web3.web3Provider)
        );
        Swal.fire({
          text: "Withdrew all tokens.",
          icon: "info",
          confirmButtonText: "OK",
        });
        await handleGetInfo();
        setWithdrawAmount("0");
        setWithdrawActive(false);
      } catch (e) {
        setWithdrawIsLoading(false);
        console.log(e);
      }
    } else {
      try {
        setWithdrawIsLoading(true);
        await cohortApi.withdraw(
          await getCohortContract(web3Context.web3.web3Provider),
          ethToWei(withdrawAmount)
        );
        Swal.fire({
          text: `Withdrew ${withdrawAmount}`,
          icon: "info",
          confirmButtonText: "OK",
        });
        await handleGetInfo();
        setWithdrawAmount("0");
      } catch (e) {
        setWithdrawIsLoading(false);
        console.log(e);
      }
    }
  };

  const handleApprove = async (e) => {
    e.preventDefault();
    dispatch(
      pageFarmCohort({
        rasko: apy,
        busd: yearlyBusd,
        wbnb: yearlyWbnb,
        amount: depositAmount,
        method: "approve",
      })
    );
    // try {
    //   setAproveIsLoading(true);
    //   await approveErc20(
    //     web3Context.web3.web3Provider,
    //     rAskoAddress,
    //     rAskoCohortAddress
    //   );
    //   alert("Approved!");
    //   await handleGetInfo();
    // } catch (e) {
    //   console.log(e);
    // }
  };

  const handleClaim = async (e) => {
    e.preventDefault();
    if (rewards[0] == 0 && rewards[1] == 0 && rewards[2] == 0) {
      Swal.fire({
        text: "You have no rewards to claim",
        icon: "info",
        confirmButtonText: "Ok",
      });
      return;
    }
    try {
      setClaimIsLoading(true);
      await cohortApi.claim(
        await getCohortContract(web3Context.web3.web3Provider)
      );
      Swal.fire({
        text: "Claimed!",
        icon: "info",
        confirmButtonText: "OK",
      });
      await handleGetInfo();
      setClaimActive(false);
    } catch (e) {
      setClaimIsLoading(false);
      console.log(e);
    }
  };

  const handleGetInfo = async () => {
    try {
      const cohortContract = await getCohortContract(
        web3Context.web3.web3Provider
      );
      const [
        userApproved,
        reward0,
        reward1,
        reward2,
        remaining0,
        remaining1,
        remaining2,
        userDeposited,
        rate,
        balance,
        allDeposited,
        share,
        busdSpeed,
        wbnbSpeed,
      ] = await Promise.all([
        isApprovedForAmount(
          web3Context.web3.web3Provider,
          rAskoAddress,
          web3Context.currentAccountAddress,
          rAskoCohortAddress,
          "1"
        ),
        cohortApi.getUserClaimableRewards(
          cohortContract,
          web3Context.currentAccountAddress,
          0
        ),
        cohortApi.getUserClaimableRewards(
          cohortContract,
          web3Context.currentAccountAddress,
          1
        ),
        cohortApi.getUserClaimableRewards(
          cohortContract,
          web3Context.currentAccountAddress,
          2
        ),
        cohortApi.getRemainingTokens(cohortContract, 0),
        cohortApi.getRemainingTokens(cohortContract, 1),
        cohortApi.getRemainingTokens(cohortContract, 2),
        cohortApi.getUserDeposited(
          cohortContract,
          web3Context.currentAccountAddress
        ),
        cohortApi.getRate(cohortContract),
        getERC20BalanceFromAddress(
          web3Context.web3.web3Provider,
          rAskoAddress,
          web3Context.currentAccountAddress
        ),
        cohortApi.getAllDeposited(cohortContract),
        cohortApi.getUserShare(
          cohortContract,
          web3Context.currentAccountAddress
        ),
        cohortApi.getRewardSpeed(cohortContract, 1),
        cohortApi.getRewardSpeed(cohortContract, 2),
      ]);
      setDepositedAmount(weiToEth(userDeposited));
      setUserApproved(userApproved);
      setRewards([weiToEth(reward1), weiToEth(reward0), weiToEth(reward2)]);
      if (
        weiToEth(reward0) != 0 ||
        weiToEth(reward1) != 0 ||
        weiToEth(reward2) != 0
      ) {
        setClaimActive(true);
      }
      if (weiToEth(userDeposited) != 0) {
        setWithdrawActive(true);
      }
      setBusd(roundString(weiToEth(remaining1), 4));
      setRasko(roundString(weiToEth(remaining0), 4));
      setBnb(roundString(weiToEth(remaining2), 4));
      setApy(roundString(weiToEth(rate.mul(100)), 4));
      setUserBalance(weiToEth(balance));
      setAproveIsLoading(false);
      setClaimIsLoading(false);
      setWithdrawIsLoading(false);
      setAllDepositedAmount(weiToEth(allDeposited));
      setUserShare(weiToEth(share) * 100);
      // 31536000 seconds in a year
      let busdAmount = busdSpeed.mul(31536000);
      busdAmount = busdAmount.mul(1000);
      let wbnbAmount = wbnbSpeed.mul(31536000);
      wbnbAmount = wbnbAmount.mul(1000);
      if (allDeposited != 0) {
        busdAmount = busdAmount.div(allDeposited);
        wbnbAmount = wbnbAmount.div(allDeposited);
        setYearlyBusd(roundString(busdAmount.toString(), 4));
        setYearlyWbnb(roundString(wbnbAmount.toString(), 4));
      } else {
        setYearlyBusd(roundString(weiToEth(busdAmount), 4));
        setYearlyWbnb(roundString(weiToEth(wbnbAmount), 4));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(async () => {
    if (web3Context.web3.web3Provider && web3Context.currentAccountAddress) {
      try {
        // check user approved
        await handleGetInfo();
      } catch (error) {
        console.log(error);
      }
    }
  }, [web3Context]);

  useEffect(async () => {
    await setAllDepositedAmount(weiToEth(allDeposited));
  }, [web3Context]);


  useEffect( () => {
    if(web3Context.currentAccountAddress.length < 5){
      dispatch(connectWallet());
    } 
  }, [web3Context])

  return (
    <div>
      <Helmet>
        <title>
          Cohort Farm - Earn Yields and Rewards - APR Up To 120.0% | rASKO
        </title>
        <meta
          name="description"
          content="Multi-token farm for rASKO and premium crypto assets on Binance Smart Chain. Up to 50% of collected platform fees go to farmers."
        />
      </Helmet>
      <div className="farm farm_cohort">
        <header className="farm__header">
          <h4>Cohort Farm</h4>{" "}
        </header>
        <form class="form block-view">
          <div className="cohort_farm_naib_form">
            <div className="cohort_farm_content_header">
              <img src={RASKO} />
              <h3>
                APR UP TO <span>{apy}%</span>
              </h3>
              <h3>
                Amount of rASKO tokens deposited by all users:{" "}
                <span>{roundString(allDepositedAmount, 4)}</span> rASKO{" "}
                {/* <span>($1234)</span> */}
              </h3>
            </div>
            <div className="cohort_farm_content">
              <div className="cohort_farm_content_top">
                <h3>
                  Your rASKO Balance: <span>{roundString(userBalance, 4)}</span>{" "}
                  <span> </span> rASKO {/* <span>($1234)</span> */}
                </h3>
                <h3>
                  Your Share of the Staking Pool:{" "}
                  <span>
                    {Math.round((userShare + Number.EPSILON) * 10000) / 10000}%
                  </span>
                </h3>
                <span>Current Rate of Rewards Per 1000 rASKO</span>
                <div>
                  <div className="cohort_farm_content_top">
                    <label>
                      <strong>
                        <img src={WBNB} /> WBNB
                      </strong>
                      <div className="removeliq__input">{yearlyWbnb}</div>
                    </label>
                    <label>
                      <strong>
                        <img src={BUSD} />
                        BUSD
                      </strong>
                      <div className="removeliq__input">{yearlyBusd}</div>
                    </label>
                  </div>
                </div>
                <span>Total Rewards Available for Farming</span>
                <div>
                  <div className="cohort_farm_content_top">
                    <label>
                      <strong>
                        <img src={RASKO} /> rASKO
                      </strong>
                      <div className="removeliq__input">{rasko}</div>
                    </label>
                    <label>
                      <strong>
                        <img src={WBNB} /> WBNB
                      </strong>
                      <div className="removeliq__input">{bnb}</div>
                    </label>
                    <label>
                      <strong>
                        <img src={BUSD} />
                        BUSD
                      </strong>
                      <div className="removeliq__input">{busd}</div>
                    </label>
                  </div>
                </div>
              </div>
              <div className="farm_cohort_midle">
                <div className="farm_cohort_midle_block">
                  <div>
                    rASKO Deposited:{" "}
                    <span>{roundString(depositedAmount, 4)}</span>
                  </div>
                  <span>Deposit rASKO</span>
                  <label>
                    <strong>
                      <img src={RASKO} /> rASKO
                    </strong>

                    <input
                      className="removeliq__input"
                      value={roundString(depositAmount, 4)}
                      onChange={changeDeposit}
                    />
                    <span>{roundString(userBalance, 4)} Available </span>
                    <button onClick={setMaxDeposit}>MAX</button>
                  </label>
                  <button
                    className={
                      !approveActive
                        ? "farm-item__btn disabled"
                        : "farm-item__btn "
                    }
                    onClick={userApproved ? handleDeposit : handleApprove}
                  >
                    {userApproved ? <>Deposit</> : <>Approve</>}

                    {aproveIsLoading ? <CohortLoading /> : null}
                  </button>
                </div>
                <div className="farm_cohort_midle_block">
                  <span>Amount to Withdraw</span>
                  <label>
                    <strong>
                      <img src={RASKO} /> rASKO
                    </strong>
                    <input
                      className="removeliq__input"
                      value={withdrawAmount}
                      onChange={changeWithdraw}
                      style={{ paddingRight: "40px" }}
                    />
                    <button onClick={setMaxWithdraw}>MAX</button>
                    <span>{roundString(depositedAmount, 4)} Available </span>
                  </label>
                  <button
                    className={
                      !withdrawActive
                        ? "farm-item__btn disabled"
                        : "farm-item__btn "
                    }
                    onClick={handleWithdraw}
                  >
                    Withdraw {withdrawIsLoading ? <CohortLoading /> : null}
                    {!withdrawActive ? (
                      <span className="btn_error">
                        Your rASKO Token Deposit Equal 0
                      </span>
                    ) : null}
                  </button>
                </div>
              </div>
              <div className="cohort_farm_content_top">
                <span>Your Accumulated Rewards</span>
                <div>
                  <label>
                    <strong>
                      <img src={RASKO} /> rASKO
                    </strong>
                    <div className="removeliq__input">
                      {roundString(rewards[1], 4)}
                    </div>
                  </label>
                  <label>
                    <strong>
                      <img src={WBNB} /> WBNB
                    </strong>
                    <div className="removeliq__input">
                      {roundString(rewards[2], 4)}
                    </div>
                  </label>
                  <label>
                    <strong>
                      <img src={BUSD} />
                      BUSD
                    </strong>
                    <div className="removeliq__input">
                      {roundString(rewards[0], 4)}
                    </div>
                  </label>
                </div>
                <button
                  className={
                    !claimActive ? "farm-item__btn disabled" : "farm-item__btn "
                  }
                  onClick={handleClaim}
                >
                  Claim Rewards {claimIsLoading ? <CohortLoading /> : null}
                  {!claimActive ? (
                    <span className="btn_error">You Don`t Have Rewards</span>
                  ) : null}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
